import React, { useEffect, useState } from "react";
import OurStory from "./privacy-main/OurStory";
import "./Privacy.css";
import { privacyPolicy } from "../../utils/apis/common/Common";
import parse from 'html-react-parser';

const Privacy = () => {
  const [getprivacy, setPrivacy] = useState();
  const getProject = async () => {
    const res = await privacyPolicy();
    if (res?.success) {
      setPrivacy(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getProject();
  }, []);

  return (
    <>
      <section className="Privacy_Policy">
        <div className="bg_img_div">
          <div className="white_bg_div">
            <div className="container">
              <p className="section_title">Privacy Policy</p>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="main_content_div">
            <p className="sub-text my-4">
              {" "}
              {typeof getprivacy?.description === "string"
                ? parse(getprivacy?.description)
                : ""}
            </p>
          </div>
        </div>
      </section>

      {/* old code */}
      {/* <OurStory /> */}
    </>
  );
};

export default Privacy;
